import React, { Component } from 'react'
import { translate } from '../../utils/useful'

import MenuMainItem from './MenuMainItem'


export default class MenuToolbar extends Component {

    state = {}

    componentDidMount() {
        // console.log("componentDidMount !!!!!")
    }

    componentDidUpdate = (prevProps) => {
        // if (prevProps.data != this.props.data) { }
    }

    render() {
        
        let menu = this.props.frame?.menu
        let menuList = this.props.frame?.menu?.list
        return (
            <div className='w-100 flexc '>
                {(menu?.active && menu.type == 'basic' && Array.isArray(menuList)) && (
                    menuList.filter((a) => a.parents?.length == 0).map((item, index) => {
                        // console.log("EEE")
                        return (
                            <div className='flexc' key={index}>
                                <MenuMainItem item={item} list={menuList} permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler}  isMobile={this.props.isMobile} setCurrentHead={this.props.setCurrentHead} />
                            </div>
                        )
                    })
                )}
                {/* <DataMenu permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} setCurrentHead={this.props.setCurrentHead} />
                <ToolsMenu permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} />
                <SettingMenu permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} /> */}
                {/* <SelectMenu permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} /> */}

                {/* {this.props.showStack && (
                    <div className='flexcc' >
                        <button className='flexc  px-2  white' onClick={() => this.props.functionsHandler('collectionView', 'openSelectStack')} >
                            <div className='flexcc mrd-2 '>
                                <img className={(!this.props.colors?.iconInvert ? 'invert' : '')} src="/assets/icons/useful/stack.png" height={'12px'} />
                            </div>
                            <p className='font-size-14 white ' style={{ color: this.props.colors?.textColor }}>{translate("Stack")}</p>
                        </button>
                    </div>
                )} */}
            </div>
        )
    }
}
